module.exports = __webpack_public_path__ + "static/media/phone.6dba0ec2.svg";